// Saves initial columns width to localStorage
export const saveInitialColsWidth = (item: string, cols: string) => {
  localStorage.setItem(item, cols);
};
